import * as actionType from '../actionsTypes';


export const loginAction = payload => (dispatch => dispatch({ type: actionType.LOGIN_SUCCESS, payload }));
export const logoutAction = () => (dispatch => dispatch({ type: actionType.LOGOUT_SUCCESS }));
export const forgotPasswordAction = () =>(dispatch => dispatch({type: actionType.FORGOT_PASSWORD_SUCCESS }))
export const resetPasswordAction = () =>(dispatch => dispatch({type: actionType.RESET_PASSWORD_SUCCESS }))
export const changePasswordAction = () =>(dispatch => dispatch({type: actionType.CHANGE_PASSWORD_SUCCESS }))